<template>
    <div class = "background">
        <div class="layer">
            <div @mouseenter="onMouseEnter" @mouseleave="onMouseLeave" style="height: 80px; position: fixed; top: 0; left: 0; right: 0; z-index: 80;">
            <NavBar v-if="showNavBar" :selectedItem="selectedItem"/>
            </div>
            <div class="image-gallery">
                <div class="column" v-for="(column, columnIndex) in columns" :key="columnIndex">
                  <div class="photo-area" 
                  v-for="image in column"
                  :key="image.id"
                  @mouseenter="hoverImage(image)"
                  @mouseleave="leaveImage(image)"
                  @click="pageOpen('eventDetail', image.id)"
                  >
                    <div class="photo-top"></div>
                    <div class="image-wrapper">
                      <div class="photo-left"></div>
                      <div class="photo-middle">
                        <img 
                          :src="image.image" 
                          class="gallery-image" 
                          
                        />
                        <div class="overlay" v-if="image.isHovered">
                          <span class="image-text">{{ image.text }}</span>
                        </div>
                      </div>
                      
                      <div class="photo-right"></div>
                    </div>  
                    <div class="photo-bottom"></div>
                  </div>
                </div>
                  
                
            </div>
        </div>
    </div>
    
    
</template>

<script scoped>
    import NavBar from './NavBar.vue'

    export default {
        name: 'EventPage',
        components: {
            NavBar,
        },
        data() {
            return {
                showNavBar: true,
                selectedItem:"OurBusiness",
                item : '00675',
                images: [
                    { id: "001", image: require('@/assets/Event/FashionNight.png'), text: "IHG Sanlitun Fashion Night Out" },
                    { id: "002", image: require('@/assets/Event/InternationalTempleFair.jpg'), text: "International Temple Fair" },
                    { id: "003", image: require('@/assets/Event/JinMusicConcert.jpg'), text: "Jin Music Concert" },
                    { id: "004", image: require('@/assets/Event/WhiteParty.png'), text: "White Party" },
                    { id: "005", image: require('@/assets/Event/YeShanghai.png'), text: "Ye‘ Shanghai" },
                    { id: "006", image: require('@/assets/Event/NYEParties.jpg'), text: "NYE Parties" },
                    { id: "007", image: require('@/assets/Event/FairyTale.jpg'), text: "Fairy Tale X'mas Eve Dinner - Snow White and the Seven Dwarfs" },
                    { id: "008", image: require('@/assets/Event/SheguangHu.jpg'), text: "SHEGUANG HU Fashion Night Out @ Regent Beijing" },
                    
                    // 添加更多图片
                ],
                columns: [[], [], [], []] // 初始化四列布局
            }
        },
        methods: {
            onMouseEnter() {
                this.showNavBar = true;
            },
            onMouseLeave() {
                this.showNavBar = true;
            },
            handleNavigation(id) {
                this.$router.push({ name: id });
                console.log("Handling navigation to:", id);
            },
            pageOpen(id,text){
                this.item = text
                console.log("检测到点击",id, this.item)
                this.$router.push({ name: id, params : { item : this.item } })
                this.$emit('navigate', id); // 发出 `navigate` 事件，传递点击的id
            },
            loadPhotos() {
                // 根据屏幕宽度设置列数
                const columnCount = window.innerWidth < 768 ? 2 : 4;

                // 初始化 columns 数组
                this.columns = Array.from({ length: columnCount }, () => []);

                // 分配图片到列
                this.images.forEach((image, index) => {
                    image.isHovered = false; // 初始化悬浮状态
                    this.columns[index % columnCount].push(image);
                });
            },
            hoverImage(image) {
                image.isHovered = true;
            },
            leaveImage(image) {
                image.isHovered = false;
            },
        },
        mounted() {
            this.loadPhotos(); // 默认加载 band 的照片
            window.addEventListener("resize", this.loadPhotos);
        },
        beforeUnmounted() {
    window.removeEventListener("resize", this.loadPhotos);
}
        
    }
    
</script>

<style scoped>
  
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box; /* 确保包括padding和border在内的总宽度和高度 */
    overflow-x:hidden;
    scroll-behavior: smooth;
  }
  .background{
    height: 100vh;
    width: 100vw;
    background: url(../assets/background.png) no-repeat center center;
    background-size: cover;
    z-index: -1; /* 确保背景位于内容之下 */
  }
  .layer{
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;

  }
  .image-gallery {
    margin-top: 80px;
    padding-top: 16px;
    width: 85%;
    display: flex;
    gap: 16px;
}

.column {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.image-wrapper {
  position: relative;
  cursor: pointer;
  display: flex;
  flex-direction: row;
}
.photo-middle{
  width: 100%;
  height: auto;
  border-radius: 0px;
}
.gallery-image {
  width: 100%;
  height: auto;
  border-radius: 0px;
}
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  /* background:linear-gradient(90deg,rgba(186, 162, 115, 1),  rgba(81, 69, 46, 1));  */
  background-image: linear-gradient( 109.9deg,  rgba(251,189,100,1) 1.8%, rgba(255,207,139,1) 95.4% );
  color:rgb(56, 48, 31);
  font-size: 1.5rem;
  opacity: 0;
  transition: opacity 0.3s ease;
  border-radius: 0px;
}
.image-wrapper:hover .overlay {
  opacity: 1;
}
.photo-area{
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.5), 0 6px 20px 0 rgba(0, 0, 0, 0.5);
    }
.photo-top{
  width: 100%;
  height: 16px;
  background-color: black;
}
.photo-bottom{
  width: 100%;
  height: 16px;
  background-color: black;
}
.photo-left{
  width: 16px;
  height: auto;
  background-color: black;
}
.photo-right{
  width: 16px;
  height: auto;
  background-color: black;
}
.image-text {
  text-align: center;
}
  
  #app {
    font-family: Futura, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    margin-top: 0px;
  }
  @media (max-width: 768px) {
      .centered-text {
        font-size: 1em; 
        color: #FBD872; 
        z-index: 10; /* 确保文字显示在背景图片之上 */
        letter-spacing: 0.1em;
        line-height: 40px;
        position: relative;
        top: 40%;
        z-index: 1;
      }
      .image-gallery {
        margin-top:48px;
        display: grid;
        grid-template-columns: repeat(2, 1fr); /* 设置为两列布局 */
        gap: 4px;
        width:95%;
      }
    .column {
        display: flex;
        flex-direction: column;
        gap: 4px;
    }
  }
  
  
</style>
  